import { PreviewModalForm } from "./PreviewModalForm"


const PreviewModalFormWrapper = () => {
    return (<PreviewModalForm />)
}

export {PreviewModalFormWrapper}